(function () {
    'use strict';
    
    angular
    .module('laekkerAI.tablet')
    .controller('PlannedProductionJobController', [
        PlannedProductionJobController
    ]);

    function PlannedProductionJobController() {
        var $ctrl = this;
    
        $ctrl.$onInit = function () {
        };
    
        $ctrl.$onChanges = function(changes) {
        };
    
        $ctrl.$onDestroy = function () {
        };
    
    }
}());